import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import CruiseUrgencyLabel from 'components/Cruises/Common/CruiseUrgencyLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import { isCruiseV1Offer } from 'lib/offer/offerTypes'
import React, { useMemo } from 'react'
import AgentHubAdditionalCommissionLabel from 'agentHub/components/AgentHubAdditionalCommissionLabel'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTileLabels({ view }: Props) {
  // TODO: Remove this once the A/B test is complete https://aussiecommerce.atlassian.net/browse/CRUZ-3360
  const cruiseSearchTileRedesignEnabled = getOptimizelyEnabledDecision(useOptimizelyExperiment(OptimizelyExperiments.cruiseSearchTileRedesign))

  const filteredUrgencyLabels = useMemo(() => {
    if (!cruiseSearchTileRedesignEnabled) {
      return view.urgencyLabels
    }
    // In variant, filter out 'sale' type labels as they'll be shown in the features section
    return view.urgencyLabels.filter(label => label.type !== 'sale')
  }, [cruiseSearchTileRedesignEnabled, view.urgencyLabels])

  return <LabelGroup>
    {filteredUrgencyLabels.map(label => <CruiseUrgencyLabel
      key={label.type}
      offer={view.offer}
      label={label}
    />)}
    <AgentHubAdditionalCommissionLabel offerId={view.offer?.id} />
    {isCruiseV1Offer(view.offer) && view.offer.badge && <OfferBadgeLabel badge={view.offer.badge} />}
  </LabelGroup>
}

export default CruiseSearchTileLabels
